import { render, staticRenderFns } from "./AddGather.vue?vue&type=template&id=493a96e2"
import script from "./AddGather.vue?vue&type=script&lang=js"
export * from "./AddGather.vue?vue&type=script&lang=js"
import style0 from "./AddGather.vue?vue&type=style&index=0&id=493a96e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports